import { render } from "./AddAttribute.vue?vue&type=template&id=a2eda5de&ts=true"
import script from "./AddAttribute.vue?vue&type=script&lang=ts"
export * from "./AddAttribute.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__